import React from "react";
import ProductCollection from "../../../../components/Layout/ProductCollection";
import { Radio } from "../../../../components/Form";
import { getMessage } from "../../../../lib/translator";
const InfluencerCollection = () => {
  return {
    preview: ProductCollection,
    fields: function () {
      return (
        <div>
          <div className="form-sections">
            <div className="form-section">
              <Radio
                name="layoutType"
                label={getMessage("themes.layoutType")}
                required
                options={[
                  {
                    text: getMessage("themes.grid"),
                    value: "GRID",
                  },
                  {
                    text: getMessage("themes.scroller"),
                    value: "SCROLLER",
                  },
                ]}
                {...this.generateStateMappers({
                  stateKeys: ["layoutType"],
                })}
              />
            </div>
            <div className="form-section">
              <Radio
                name="pagination"
                label={getMessage("themes.loadMoreType.influencer")}
                required
                options={[
                  {
                    text: getMessage("themes.infiniteScroll"),
                    value: "INFINITE",
                  },
                  {
                    text: getMessage("themes.seeAll"),
                    value: "SEEALL",
                  },
                ]}
                {...this.generateStateMappers({
                  stateKeys: ["loadMoreType"],
                })}
              />
            </div>
          </div>
        </div>
      );
    },
  };
};

export default InfluencerCollection;
